import { render, staticRenderFns } from "./SpinnerComponent.vue?vue&type=template&id=30ace1bc"
var script = {}
import style0 from "./SpinnerComponent.vue?vue&type=style&index=0&id=30ace1bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports